/* ============================================
   ELITE WELLNESS — THEME JS
   ============================================ */

(function () {
  'use strict';

  /* --- Sticky Header --- */
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* --- Desktop Mega Menu Click Toggle --- */
  var navItemsWithMenu = document.querySelectorAll('.site-header__nav-item.has-megamenu');
  navItemsWithMenu.forEach(function (item) {
    var link = item.querySelector('.site-header__nav-link');
    if (link) {
      link.addEventListener('click', function (e) {
        if (window.innerWidth > 768) {
          e.preventDefault();
          e.stopPropagation();
          var isOpen = item.classList.contains('is-open');
          closeAllMegaMenus();
          if (!isOpen) {
            item.classList.add('is-open');
            // Lock the header at the current scroll position so it scrolls away naturally
            if (header) {
              header.style.top = window.scrollY + 'px';
              header.classList.add('is-absolute');
            }
          }
        }
      });
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.site-header__nav-item.has-megamenu')) {
      closeAllMegaMenus();
    }
  });

  function closeAllMegaMenus() {
    navItemsWithMenu.forEach(function (item) {
      item.classList.remove('is-open');
    });
    if (header) {
      header.classList.remove('is-absolute');
      header.style.top = '';
    }
  }

  /* --- Search Toggle --- */
  var searchToggle = document.getElementById('search-toggle');
  var searchBar = document.getElementById('search-bar');
  var searchClose = document.getElementById('search-close');

  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      var isOpen = searchBar.classList.toggle('is-open');
      searchBar.setAttribute('aria-hidden', String(!isOpen));
      if (isOpen) {
        var input = searchBar.querySelector('input');
        if (input) setTimeout(function () { input.focus(); }, 50);
      }
    });
  }
  if (searchClose && searchBar) {
    searchClose.addEventListener('click', function () {
      searchBar.classList.remove('is-open');
      searchBar.setAttribute('aria-hidden', 'true');
    });
  }

  /* --- RTL detection (mirrors html[dir] attribute set by theme.liquid) --- */
  var isRTL = document.documentElement.getAttribute('dir') === 'rtl';

  /* --- Mobile Nav --- */
  var menuToggle = document.querySelector('.site-header__menu-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  var mobileNavOverlay = document.getElementById('mobile-nav-overlay');
  var mobileNavClose = document.getElementById('mobile-nav-close');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (mobileNavOverlay) {
      mobileNavOverlay.classList.add('is-open');
      mobileNavOverlay.setAttribute('aria-hidden', 'false');
    }
    document.body.style.overflow = 'hidden';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (mobileNavOverlay) {
      mobileNavOverlay.classList.remove('is-open');
      mobileNavOverlay.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);

  /* --- Mobile Nav: expand/collapse submenus --- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.mobile-nav__toggle');
    if (!toggle) return;

    var row = toggle.closest('.mobile-nav__link-row');
    var item = row ? row.closest('.mobile-nav__item, .mobile-nav__sub-item') : null;
    if (!item) return;

    // Find the immediate sub-list inside this item
    var subList = item.querySelector(':scope > .mobile-nav__sub-list, :scope > .mobile-nav__sub-sub-list');
    if (!subList) return;

    var isOpen = !subList.hidden;
    subList.hidden = isOpen;
    toggle.setAttribute('aria-expanded', String(!isOpen));
    toggle.classList.toggle('is-open', !isOpen);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileNav();
      if (searchBar) {
        searchBar.classList.remove('is-open');
        searchBar.setAttribute('aria-hidden', 'true');
      }
    }
  });

  /* --- Quick Add to Cart --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-card__quick-add, .col-product-card__quick-add');
    if (!btn) return;
    var variantId = btn.dataset.productId;
    if (!variantId) return;

    var originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span class="material-icons" style="animation: spin 0.6s linear infinite;">refresh</span>';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart add failed');
      return res.json();
    })
    .then(function () {
      btn.innerHTML = '<span class="material-icons">check</span>';
      updateCartCount();
      setTimeout(function () {
        btn.innerHTML = originalHTML;
        btn.disabled = false;
      }, 1500);
    })
    .catch(function () {
      btn.innerHTML = originalHTML;
      btn.disabled = false;
    });
  });

  /* --- Update Cart Count --- */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var countEl = document.querySelector('.site-header__cart-count');
        if (cart.item_count > 0) {
          if (!countEl) {
            var cartLink = document.querySelector('.site-header__cart');
            if (cartLink) {
              var span = document.createElement('span');
              span.className = 'site-header__cart-count';
              span.textContent = cart.item_count;
              cartLink.appendChild(span);
            }
          } else {
            countEl.textContent = cart.item_count;
          }
        } else if (countEl) {
          countEl.remove();
        }
      });
  }

  /* --- Spin animation for loading --- */
  var style = document.createElement('style');
  style.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(style);

  /* --- RTL: Best Sellers slider scroll direction fix ---
     The inline slider JS in best-sellers.liquid uses scrollBy.
     When dir=rtl, browsers handle scrollLeft differently.
     We patch scrollBy on the slider containers to flip direction. */
  if (isRTL) {
    document.querySelectorAll('.best-sellers__slider').forEach(function (slider) {
      var origScrollBy = slider.scrollBy.bind(slider);
      slider.scrollBy = function (opts) {
        if (opts && typeof opts.left === 'number') {
          opts.left = -opts.left;
        }
        origScrollBy(opts);
      };
    });
  }

})();
